import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const actionList = createAsyncThunk('action/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `action`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const actionDetails = createAsyncThunk('action/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `action/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addAction = createAsyncThunk('action/add', async (data) => {

    let actions = data?.values?.actions?.map(val => ({
        "sub_action_name": val?.name,
        "route": val?.route,
        "show_in_menu": val?.showInMenu,
    }))

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'action',
            data: {
                "module_id": data?.values?.module,
                "action_name": data?.values?.name,
                "description": data?.values?.description,
                "api_endpoint": data?.values?.apiEndPoint,
                "priority": data?.values?.priority,
                "subAction": actions,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateAction = createAsyncThunk('action/update', async (data) => {

    let actions = data?.values?.actions?.map(val => ({
        "id": val?.id,
        "sub_action_name": val?.name,
        "route": val?.route,
        "show_in_menu": val?.showInMenu,
    }))

    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'action',
            data: {
                "action_id": data?.values?.id,
                "module_id": data?.values?.module,
                "action_name": data?.values?.name,
                "description": data?.values?.description,
                "api_endpoint": data?.values?.apiEndPoint,
                "priority": data?.values?.priority,
                "subAction": actions,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delAction = createAsyncThunk('action/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `action/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const action = createSlice({
    name: 'action',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(actionList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(actionDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default action.reducer;